/**
 * @license
 * Copyright TWISS.IO
 * All Rights Reserved.
 * Licensed under the MIT License.
 */

export * from "./associate-add-dialog/associate-add-dialog.component";
export * from "./salesforce-add-axa-scheme-dialog/salesforce-add-axa-scheme-dialog.component";
export * from "./salesforce-add-banding-lfa-dialog/salesforce-add-banding-lfa-dialog.component";
export * from "./salesforce-add-banding-gi-dialog/salesforce-add-banding-gi-dialog.component";
export * from "./salesforce-add-movement-dialog/salesforce-add-movement-dialog.component";
export * from "./salesforce-add-provider-code-dialog/salesforce-add-provider-code-dialog.component";
export * from "./submission-media-dialog/submission-media-dialog.component";
export * from "./bsc-tag-submission-dialog/bsc-tag-submission-dialog.component";

export * from "./salesforce-offboard-dialog/salesforce-offboard-dialog.component";

export * from "./bsc-batch-add-dialog/bsc-batch-add-dialog.component";
export * from "./payroll-batch-add-dialog/payroll-batch-add-dialog.component";

export * from "./products-add-series-dialog/products-add-series-dialog.component";
export * from "./products-add-options-dialog/products-add-options-dialog.component";
export * from "./products-edit-options-dialog/products-edit-options-dialog.component";
export * from "./products-add-riders-dialog/products-add-riders-dialog.component";
export * from "./product-options-tag-riders-dialog/product-options-tag-riders-dialog.component";  